// @flow

import { authenticatedFetch } from '../../../api/request';

export default function getHeadCoachInfo() {
    return authenticatedFetch(`/v5/headCoach`);
}
